'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnterpriseRadioButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(EnterpriseRadioButton, _Component);

  function EnterpriseRadioButton() {
    (0, _classCallCheck3.default)(this, EnterpriseRadioButton);
    return (0, _possibleConstructorReturn3.default)(this, (EnterpriseRadioButton.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseRadioButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(EnterpriseRadioButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          id = _props.id,
          label = _props.label,
          name = _props.name,
          checked = _props.checked,
          onChange = _props.onChange,
          disabled = _props.disabled,
          value = _props.value,
          restProps = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'id', 'label', 'name', 'checked', 'onChange', 'disabled', 'value']);

      var styles = require('./EnterpriseRadioButton.scss');

      return _react2.default.createElement(
        'label',
        (0, _extends3.default)({}, restProps, { htmlFor: id, className: (0, _classnames2.default)(className, styles.root) }),
        _react2.default.createElement('input', {
          type: 'radio',
          name: name,
          id: id,
          checked: checked,
          onChange: onChange,
          disabled: disabled,
          value: value
        }),
        _react2.default.createElement(
          'span',
          { className: styles.label },
          label,
          children
        )
      );
    }
  }]);
  return EnterpriseRadioButton;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  id: _react.PropTypes.string,
  label: _react.PropTypes.string,
  name: _react.PropTypes.string,
  checked: _react.PropTypes.bool,
  onChange: _react.PropTypes.func
}, _temp);
exports.default = EnterpriseRadioButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseRadioButton/EnterpriseRadioButton.jsx
// module id = 1607
// module chunks = 0